import React from 'react'

function QuizDay() {
  return (
    <div>QuizDay</div>
  )
}

export default QuizDay